import React, { useState } from 'react';
import { Typography } from '@naf-simba/building-blocks-typography';
import { Link } from '@naf-simba/elements-links';
import * as S from './CompetitionResults.styles';
import { CompetitionStyleVariant } from '../Competition.types';
import CompetitionTermsAndConditions from '../CompetitionTermsAndConditions/CompetitionTermsAndConditions';

interface CompetitionResultsProps {
  isCorrect: boolean;
  style: CompetitionStyleVariant;
  termsLinkSlug?: string;
}

const CompetitionResults = ({ isCorrect, style, termsLinkSlug }: CompetitionResultsProps) => {
  const [showTerms, setShowTerms] = useState(false);
  const handleShowTerms = () => setShowTerms(true);
  const handleHideTerms = () => setShowTerms(false);
  const hasTerms = Boolean(termsLinkSlug);

  return showTerms && termsLinkSlug ? (
    <CompetitionTermsAndConditions style={style} onHideTerms={handleHideTerms} termsLinkSlug={termsLinkSlug} />
  ) : (
    <S.AnswerResultContainer>
      {isCorrect ? (
        <>
          <Typography variant="headlineXS">Riktig svar.</Typography>
          <Typography variant="headlineXS">Du er nå med i trekningen!</Typography>
          <S.FireworksImage />
          {hasTerms && (
            <S.StyledButtonLink>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid -- Link used as a non-navigating action */}
              <Link onClick={handleShowTerms} text="Konkurransevilkår" inverted={style === 'spruce'} />
            </S.StyledButtonLink>
          )}
        </>
      ) : (
        <>
          <Typography variant="headlineXS">Feil svar</Typography>
          <S.ThumbsDownImage />
          {hasTerms && (
            <S.StyledButtonLink>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid -- Link used as a non-navigating action */}
              <Link onClick={handleShowTerms} text="Konkurransevilkår" inverted={style === 'spruce'} />
            </S.StyledButtonLink>
          )}
        </>
      )}
    </S.AnswerResultContainer>
  );
};

export default CompetitionResults;
